import { useState, useCallback } from 'react';
import { check } from '@tauri-apps/plugin-updater';
import { toast } from 'sonner';
import { isTauriRuntime } from '@/utils/runtime';

export const useAutoUpdater = () => {
  const [isChecking, setIsChecking] = useState(false);
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const checkForUpdates = useCallback(async (manual = false) => {
    if (!isTauriRuntime()) {
      if (manual) toast.error('Atualizações automáticas só funcionam na versão instalada do sistema.');
      return;
    }

    try {
      setIsChecking(true);
      if (manual) toast.info('Procurando por atualizações...');
      
      const update = await check();
      
      if (update) {
        setUpdateAvailable(true);
        toast.dismiss(); // fecha toasts anteriores
        
        const shouldUpdate = window.confirm(`Uma nova versão (${update.version}) do SINSECRJ OS está disponível.\nDeseja iniciar a atualização agora?`);
        
        if (shouldUpdate) {
            setDownloading(true);
            const downloadToastId = toast.loading('Baixando atualização... Por favor, não feche o aplicativo.', {
                duration: Infinity,
            });
            
            await update.downloadAndInstall((event) => {
              switch (event.event) {
                case 'Started':
                  console.log(`Buscando ${event.data.contentLength} bytes de atualização`);
                  break;
                case 'Progress':
                  // Aqui poderíamos calcular %, mas por ora apenas mantemos o Toast vivo
                  break;
                case 'Finished':
                  break;
              }
            });
            
            toast.dismiss(downloadToastId);
            toast.success('Atualização concluída com sucesso! Feche e abra o aplicativo novamente para aplicar as mudanças.', {
                duration: 10000,
            });
        }
      } else {
        if (manual) toast.success('Você já está usando a versão mais recente do sistema!');
      }
    } catch (error) {
      console.error('Error checking for updates:', error);
      if (manual) toast.error('Ocorreu um erro ao procurar atualizações.');
    } finally {
      setIsChecking(false);
      setDownloading(false);
    }
  }, []);

  return { checkForUpdates, isChecking, updateAvailable, downloading };
};
